import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportColumnOption } from '@eview/core/domain/export/export-download.service';
import {
  ExportColumnsModalComponent,
  ExportColumnsModalResult
} from './export-columns-modal.component';

/**
 * Opens the export field/format picker. Resolves with the selection, or undefined if dismissed.
 */
export function openExportColumnsModal(
  modalService: NgbModal,
  columns: ExportColumnOption[]
): Promise<ExportColumnsModalResult | undefined> {
  const ref = modalService.open(ExportColumnsModalComponent, {
    centered: true,
    size: 'lg',
    backdrop: 'static',
    scrollable: true,
    windowClass: 'export-columns-modal-window'
  });
  ref.componentInstance.columns = columns || [];
  return ref.result.then(
    (result: ExportColumnsModalResult) => result,
    () => undefined
  );
}
